export default __webpack_public_path__ + "static/media/contestImg1.d8a4cd5c.jpg";